import React from "react"

function cleanTitle(title) {
  let cleanTitle = title.replace('SEC - ','')
  return cleanTitle
}

export default function SearchCard({
   url,
   title,
   fileType,
   fileSize,
   summary,
   displayUrl, 
}) {
  return (
    <div className="rounded-xl mb-8 p-8 search-card">
      <a href={url} className="no-underline block">
        <h2 className="h3 underline hover:underline">{cleanTitle(title)} {fileType !== 'html' ? `(${fileType.toUpperCase()}, ${Math.round(fileSize / 1024)} KB)` : ''}</h2>
        <p className="text-black">{summary}</p>
        <span className="text-primary-light-grey break-all">{displayUrl}</span>
      </a>
    </div>
  );
}